import { render, staticRenderFns } from "./HorizontalDivider.vue?vue&type=template&id=a47fef04&"
import script from "./HorizontalDivider.vue?vue&type=script&lang=js&"
export * from "./HorizontalDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports